import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'out-paginator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
})
export class PaginatorComponent {
  @Input() pageSize = 9;
  @Input() pageResults = 0;
  @Input() skipResults = 0;
  @Output() pageChange = new EventEmitter<number>();

  get totalPages() {
    return Math.max(1, Math.ceil(this.pageResults / this.pageSize));
  }

  get currentPage() {
    return Math.floor(this.skipResults / this.pageSize) + 1;
  }

  navigatePage(direction: 'next' | 'prev') {
    const increment = direction === 'next' ? this.pageSize : -this.pageSize;
    this.skipResults = Math.max(
      0,
      Math.min(
        this.skipResults + increment,
        (this.totalPages - 1) * this.pageSize
      )
    );
    this.pageChange.emit(this.skipResults);
  }

  goToPage(page: number) {
    this.skipResults = Math.max(0, (page - 1) * this.pageSize);
    this.pageChange.emit(this.skipResults);
  }
}
